<div class="hint-block">
  <div class="hint-header">
    <div class="project-name">{{activityInHint.project.name}}</div>
    <div class="jobComplexity" style.background-color="#{{activityInHint.project.jobComplexity.color}}"
         *ngIf="activityInHint.project.jobComplexity">{{activityInHint.project.jobComplexity.title}}</div>
  </div>
  <div class="hint-info customer" *ngIf="activityInHint.project.customer">
    {{activityInHint.project.customer.name}}</div>
  <div class="hint-info user" *ngIf="activityInHint.user">
    <span class="hint-type">{{activityInHint.user.name}}</span>
  </div>
  <div class="hint-info start activity-type-{{activityInHint.type.name}}" *ngIf="activityInHint.startDate">
    <span class="hint-type">{{activityInHint.type.title}}</span> at
    {{activityInHint.startDate | date:'shortTime'}} takes {{hours}}
  </div>
  <div class="hint-info punchlist"
       *ngIf="activityInHint.project.hasPunchList && !activityInHint.project.punchListReady">Has not finished
    punch-list
  </div>
  <div class="hint-info punchlist"
       *ngIf="activityInHint.project.hasPunchList && activityInHint.project.punchListReady">Punch list
    completed
  </div>
  <div class="hint-info locacation" *ngIf="activityInHint.project.location">
    {{activityInHint.project.location}}</div>
  <div class="hint-info vendor" *ngIf="activityInHint.project.finishingVendor">
    Finishing Vendor - {{activityInHint.project.finishingVendor.name}}</div>
  <div class="hint-info vendor" *ngIf="activityInHint.deliveryInstructions">
    <i class="pi pi-exclamation-triangle" style="font-size: 100%"></i>
    {{activityInHint.deliveryInstructions}}</div>
    <div class="hint-info vendor" *ngIf="activityInHint.workloadAware">
        <mat-icon class="mat-icon notranslate status-icn material-icons mat-icon-no-color">error</mat-icon>
        Workload calculations (BETA) were applied
    </div>
</div>
